import * as z from 'zod';
import { CheckoutItemTypeSchema } from '../enums/CheckoutItemType.schema';
import { CurrencySchema } from '../enums/Currency.schema';

export const CheckoutItemSchema = z.object({
  id: z.string(),
  checkoutId: z.string(),
  type: CheckoutItemTypeSchema.default("EVENT"),
  unitPriceCents: z.number().int(),
  currency: CurrencySchema.default("gbp"),
  depositCents: z.number().int().int().min(0).nullish(),
  balanceDueAt: z.coerce.date().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type CheckoutItemType = z.infer<typeof CheckoutItemSchema>;
